<template>
  <div class="login-com">
    <img src="..\assets\user.png" />
    <a-input placeholder="请输入账号" v-model="userName"></a-input>
    <br />
    <img src="..\assets\password.png" />
    <a-input
      type="password"
      placeholder="请输入密码"
      v-model="passWord"
      style="margin-top: 22px"
    ></a-input>
    <br />
    <div class="com-btn" style="margin-top: 18px">
      <a-button @click="loginSystem">登录</a-button>
    </div>
    <div class="com-sign">
      <a @click="showRegisterModal" class="register" style="color: black">
        注册新用户
      </a>
      <a-modal
        title="注册"
        v-model="visible"
        @ok="handleOk"
        width="590px"
        :centered="true"
        :maskClosable="false"
      >
        <!-- <register-new-author ref="registerNewAuthor"/> -->
        <a-row>
          <a-col :span="4" class="title">
            <span style="color: red">*</span>作者姓名：
          </a-col>
          <a-col :span="8">
            <a-input
              placeholder="请输入"
              class="input"
              v-model="author.authorName"
            />
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="4" class="title">
            <span style="color: red">*</span>性别：
          </a-col>
          <a-col :span="8">
            <a-radio-group v-model="value" @change="sexChange">
              <a-radio :value="1">男</a-radio>
              <a-radio :value="0">女</a-radio>
            </a-radio-group>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="4" class="title">
            <span style="color: red">*</span>出生年月：
          </a-col>
          <a-col :span="8">
            <a-month-picker :value="date" @change="dateChange" />
          </a-col>
        </a-row>

        <!-- <a-row>
        <a-col :span="4" class="title">学历：</a-col>
        <a-col :span="8">
          <a-select
            style="width: 100%"
            @change="eduChange"
            placeholder="请选择"
            v-model="author.eduLevel"
          >
            <a-select-option value="0">请选择</a-select-option>
            <a-select-option value="1">博士</a-select-option>
            <a-select-option value="2">硕士</a-select-option>
            <a-select-option value="3">本科</a-select-option>
            <a-select-option value="4">其他</a-select-option>
          </a-select>
        </a-col>
      </a-row> -->
        <a-row>
          <a-col :span="4" class="title">
            <!-- <span style="color: red">*</span> -->
            职称：
          </a-col>
          <a-col :span="8">
            <a-input
              placeholder="请输入"
              class="input"
              v-model="author.professionalTitle"
            />
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="4" class="title">
            <!-- <span style="color: red">*</span> -->
            研究方向：
          </a-col>
          <a-col :span="8">
            <a-input
              placeholder="请输入"
              class="input"
              v-model="author.studyDirection"
            />
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="4" class="title">
            <span style="color: red">*</span>
            所在省市：
          </a-col>
          <a-col :span="16">
            <a-select
              v-model="author.province"
              style="width: 180px"
              @change="handleProvinceChange"
              placeholder="请选择"
            >
              <a-select-option
                v-for="val in provinces"
                :value="val.name"
                :key="val.name"
              >
                {{ val.name }}
              </a-select-option>
            </a-select>
            <a-select
              v-model="author.city"
              style="width: 180px"
              placeholder="请选择"
              @change="onCityChange"
            >
              <a-select-option
                v-for="item in cities"
                :value="item.name"
                :key="item.name"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="4" class="title">
            <span style="color: red">*</span>
            邮政编码：
          </a-col>
          <a-col :span="8">
            <a-input
              placeholder="请输入"
              class="input"
              v-model="author.postCode"
            />
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="4" class="title">
            <span style="color: red">*</span>单位名称：</a-col
          >
          <a-col :span="16">
            <a-input
              placeholder="请输入"
              class="input"
              v-model="author.companyName"
            />
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="4" class="title">
            <span style="color: red">*</span>单位地址：</a-col
          >
          <a-col :span="16">
            <a-input
              placeholder="请输入"
              class="input"
              v-model="author.companyAddress"
            />
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="4" class="title">
            <span style="color: red">*</span>联系电话：
          </a-col>
          <a-col :span="8">
            <a-input
              placeholder="请输入"
              class="input"
              v-model="author.phone"
            />
          </a-col>
          <span class="note">
            *该联系电话将作为接收收稿、采用等通知的手机号
          </span>
        </a-row>
        <a-row>
          <a-col :span="4" class="title">
            <span style="color: red">*</span>E-mail：
          </a-col>
          <a-col :span="8">
            <a-input
              placeholder="请输入"
              class="input"
              v-model="author.email"
            />
          </a-col>
          <span :span="12" class="note">
            *该邮箱将作为接收收稿、采用等通知的邮件地址
          </span>
        </a-row>
        <a-row>
          <a-col :span="4" class="title">
            <span style="color: red">*</span>密码：
          </a-col>
          <a-col :span="8">
            <a-input
              type="password"
              placeholder="请输入"
              class="input"
              v-model.trim="author.pwd"
              min="8"
            />
          </a-col>
          <span :span="12" class="note"> *密码8至16位，包含大小写字母、数字和特殊字符 </span>
        </a-row>
        <a-row>
          <a-col :span="4" class="title">
            <span style="color: red">*</span>确认密码：
          </a-col>
          <a-col :span="8">
            <a-input
              type="password"
              placeholder="请输入"
              class="input"
              v-model.trim="author.rePwd"
              min="6"
            />
          </a-col>
        </a-row>
      </a-modal>
    </div>
    <div
      class="com-password"
      style="margin-top: 12px; float: right; margin-right: 12px"
    >
      <a @click="showModals" style="color: #666666"> 忘记密码？ </a>
      <a-modal
        title="重置密码"
        :visible="resetVisible"
        @ok="handleResetOk"
        @cancel="() => (resetVisible = false)"
      >
        <a-input placeholder="请输入手机号" v-model.trim="telephone" />
        <a-input
          placeholder="请输入新密码"
          style="margin-top: 15px"
          v-model.trim="newPassword"
          min="8"
        />
        <span class="note"> 密码8至16位，包含大小写字母、数字和特殊字符 </span>
        <a-row style="margin-top: 15px">
          <a-col :span="18">
            <a-input placeholder="请输入验证码" v-model.trim="phoneCode" />
          </a-col>
          <a-col :span="6" style="text-align: right">
            <a-button type="primary" @click="sendPhoneCode">
              发送验证码
            </a-button>
          </a-col>
        </a-row>
      </a-modal>
    </div>
    <!-- <p style="font-size:14px;padding-top:5px;color:#4d4c4c;">为达到最佳显示效果，推荐使用 IE 浏览器 v10以上</p> -->
  </div>
</template>

<script>
import Api from "./../api";
import moment from "moment";
import cityData from "../assets/js/city.js";

export default {
  name: "Login",
  data() {
    return {
      userName: "",
      ModalText: "Content of the modal",
      passWord: "",
      userCode: 0,
      visible: false,
      value: 1,
      date: null,
      isChecked: true,
      confirmLoading: false,
      author: {
        sex: "1",
        status: "1",
        eduLevel: "0",
        province: "",
        city: "",
      },
      provinces: cityData,
      cities: [],
      resetVisible: false,
      telephone: "",
      newPassword: "",
      phoneCode: "",
    };
  },
  created() {
    var that = this;
    document.onkeydown = function () {
      var key = window.event.keyCode;
      if (key == 13) {
        that.loginSystem();
      }
    };
  },
  mounted() {
    this.userName = "";
    this.passWord = "";
    this.$message.config({
      top: `50%`,
      duration: 2,
      maxCount: 3,
    });
    this.userType = document.getElementById("userType").value;
  },
  methods: {
    handleProvinceChange(value) {
      this.cities = cityData.find((item) => item.name == value).children;
      this.author.city = this.cities[0].name;
    },
    onCityChange(val) {
      this.author.city = val;
      this.$forceUpdate();
    },
    showRegisterModal() {
      this.author = {
        sex: "1",
        status: "1",
        eduLevel: "0",
      };
      this.visible = true;
    },
    sexChange(e) {
      this.author.sex = e.target.value;
    },
    dateChange(date, dateString) {
      this.date = date;
      this.author.birth = dateString;
    },
    eduChange(value) {
      this.author.eduLevel = value;
    },
    handleOk() {
      if (this.author.authorName == "" || this.author.authorName == undefined) {
        this.$message.error("作者姓名不能为空！");
        return;
      }
      if (this.author.birth == "" || this.author.birth == undefined) {
        this.$message.error("出生年月不能为空！");
        return;
      }
      if (
        this.author.province == "" ||
        this.author.province == undefined ||
        this.author.city == "" ||
        this.author.city == undefined
      ) {
        this.$message.error("所在省市不能为空！");
        return;
      }
      if (this.author.postCode == "" || this.author.postCode == undefined) {
        this.$message.error("邮政编码不能为空！");
        return;
      }
      //  if (
      //   this.author.professionalTitle == "" ||
      //   this.author.professionalTitle == undefined
      // ) {
      //   this.$message.error("职称不能为空！");
      //   return;
      // }
      // if (
      //   this.author.studyDirection == "" ||
      //   this.author.studyDirection == undefined
      // ) {
      //   this.$message.error("研究方向不能为空！");
      //   return;
      // }
      if (
        this.author.companyName == "" ||
        this.author.companyName == undefined
      ) {
        this.$message.error("单位名称不能为空！");
        return;
      }
      if (
        this.author.companyAddress == "" ||
        this.author.companyAddress == undefined
      ) {
        this.$message.error("单位地址不能为空！");
        return;
      }
      if (this.author.phone == "" || this.author.phone == undefined) {
        this.$message.error("联系电话不能为空！");
        return;
      }
      if (this.author.email == "" || this.author.email == undefined) {
        this.$message.error("E-mail不能为空！");
        return;
      }
      if (!this.utils.isPhone(this.author.phone)) {
        this.$message.error("手机号格式不正确！");
        return;
      }
      if (!this.utils.isEmail(this.author.email)) {
        this.$message.error("邮箱格式不正确！");
        return;
      }
      if (this.author.pwd == "" || this.author.pwd == undefined) {
        this.$message.error("密码不能为空！");
        return;
      }
      if (!this.utils.checkPwd(this.author.pwd)) {
        this.$message.error("密码必须是8至16位，包含大小写字母、数字和特殊字符");
        return;
      }
      if (this.author.pwd != this.author.rePwd) {
        this.$message.error("两次密码输入不相同！");
        return;
      }
      this.axios
        .post("/author/saveAuthor", {
          authorName: this.author.authorName,
          phone: this.author.phone,
          email: this.author.email,
          companyName: this.author.companyName,
          professionalTitle: this.author.professionalTitle,
          studyDirection: this.author.studyDirection,
          companyAddress: this.author.companyAddress,
          sex: this.author.sex,
          birth: this.author.birth,
          eduLevel: this.author.eduLevel,
          status: this.author.status,
          province: this.author.province,
          city: this.author.city,
          postCode: this.author.postCode,
          pwd: this.author.pwd,
          creater: "",
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.$message.success("注册成功！");
            this.visible = false;
          } else {
            this.$message.error(res.data.data);
          }
        });
    },
    /**
     * 登录系统
     */

    loginSystem() {
      if (this.userName == "") {
        this.$message.error("用户名不能为空！");
        return;
      }
      if (this.passWord == "") {
        this.$message.error("密码不能为空！");
        return;
      }
      //登录
      this.axios
        .post(Api.login, {
          userName: this.userName,
          pwd: this.passWord,
          userType: this.userType,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            sessionStorage.clear();
            sessionStorage.setItem("userCode", res.data.data.userCode);

            if (this.userType == 1) {
              this.$router.push("/author/myManuscript");
            } else if (this.userType == 2) {
              sessionStorage.setItem("roleCode", res.data.data.roleCode);
              this.$router.push(res.data.data.mainPage);
            } else if (this.userType == 3) {
              this.$router.push("/waitAudit");
            }

            sessionStorage.setItem("needChangePwd", res.data.data.changePwd);
            //刷新浏览器，会清空token
            //this.axios.defaults.headers.common['token'] = res.data.data;
          } else {
            this.$message.error(res.data.data);
          }
        });
    },
    showModals() {
      this.resetVisible = true;
    },
    sendPhoneCode() {
      let _this = this;
      if (this.telephone == null || this.telephone == "") {
        _this.utils.messageInfo(this, "error", "请输入手机号");
        return false;
      }
      this.axios
        .get("/systemUser/sendCode", {
          params: {
            phone: this.telephone,
            time: new Date().getTime(),
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "发送成功");
          } else {
            this.utils.messageInfo(this, "error", res.data.data);
          }
        });
    },
    handleResetOk() {
      let _this = this;
      if (this.telephone == null || this.telephone == "") {
        _this.utils.messageInfo(this, "error", "请输入手机号");
        return false;
      }
      if (this.newPassword == null || this.newPassword == "") {
        _this.utils.messageInfo(this, "error", "请输入密码");
        return false;
      }
      if (!this.utils.checkPwd(this.newPassword)) {
        _this.utils.messageInfo(
          this,
          "error",
          "密码必须是8至16位，包含大小写字母、数字和特殊字符"
        );
        return false;
      }
      if (this.phoneCode == null || this.phoneCode == "") {
        _this.utils.messageInfo(this, "error", "请输入验证码");
        return false;
      }
      this.axios
        .post("/systemUser/resetPwdByPhone", {
          phone: this.telephone,
          password: this.newPassword,
          phoneCode: this.phoneCode,
          time: new Date().getTime(),
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "重置成功");
            this.telephone = "";
            this.newPassword = "";
            this.phoneCode = "";
            this.resetVisible = false;
          } else {
            this.utils.messageInfo(this, "error", res.data.data);
          }
        });
    },
    // handleOk() {
    //   this.ModalText = "The modal will be closed after two seconds";
    //   this.confirmLoading = true;
    //   setTimeout(() => {
    //     this.visible = false;
    //     this.confirmLoading = false;
    //   }, 2000);
    // },
    handleCancel() {
      this.visible = false;
    },
    /**
     * 重置
     */
    reset() {
      this.userName = "";
      this.passWord = "";
    },
    editAuthor(authorInfo) {
      this.date = null;
      var birth = authorInfo.birth;
      if (birth != undefined && birth != "") {
        this.date = moment(birth, "YYYY-MM");
      }
      this.authorInfo = {
        sort: authorInfo.sort,
        sex: authorInfo.sex,
        birth: authorInfo.birth,
        authorSort: authorInfo.authorSort,
        corAuthor: authorInfo.corAuthor,
        authorName: authorInfo.authorName,
        eduLevel: authorInfo.eduLevel,
        companyName: authorInfo.companyName,
        companyAddress: authorInfo.companyAddress,
        phone: authorInfo.phone,
        email: authorInfo.email,
      };
      if (authorInfo.corAuthor == 1) {
        this.isCorAuthor = true;
      } else {
        this.isCorAuthor = false;
      }
      this.value = this.authorInfo.sex;
      this.modelTitle = "编辑";
      this.visible = true;
      this.oprateType = "edit";
    },
  },
};
</script>
<style>
.login-com img {
  height: 50px;
  width: 50px;
  margin-top: -6px;
  border-radius: 3px;
}
.login-com .ant-input {
  width: 310px;
  height: 50px;
  font-size: 16px;
}
.login-com input::-webkit-input-placeholder {
  font-size: 18px;
  font-family: "微软雅黑";
}
/* .login-com .com-sign {
  font-size: 18px;
  float: right;
  margin-top: 15px;
  margin-right: 25px;
} */
/* .login-com .com-btn .ant-btn-default {
  width: 364px;
  height: 50px;
  background: #005bcd;
  margin-top: 15px;
}
.login-com .com-btn .ant-btn-default span {
  font-size: 18px;
  color: #ffffff;
} */
</style>
